import { useAppID } from "hooks/use-app-id";
import type { Subtract } from "utility-types";

export interface WithAppIDProps {
    appID: string | undefined;
}

export const withAppID =
    <P extends WithAppIDProps>(
        Component: React.ComponentType<P>
    ): React.FunctionComponent<Subtract<P, WithAppIDProps>> =>
    p => {
        const appID = useAppID();
        return <Component {...(p as P)} appID={appID} />;
    };
